import { render, staticRenderFns } from "./ReceiptRefund.vue?vue&type=template&id=06fe9a58&scoped=true"
import script from "./ReceiptRefund.vue?vue&type=script&lang=js"
export * from "./ReceiptRefund.vue?vue&type=script&lang=js"
import style0 from "./ReceiptRefund.vue?vue&type=style&index=0&id=06fe9a58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fe9a58",
  null
  
)

export default component.exports